export default __webpack_public_path__ + "static/media/tower.18323f06.jpg";